// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.src = image.src;
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.classList.add('image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector('.loading-overlay__spinner');
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, overlay, zoomRatio) {
  // Calculate mouse position
  const ratio = image.naturalHeight / image.naturalWidth;
  const container = image.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${(xPosition / image.clientWidth) * 100}%`;
  const yPercent = `${(yPosition / (image.clientWidth * ratio)) * 100}%`;

  // Determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.clientWidth * zoomRatio}px`;
}

function findClosestZoomLightbox(element) {
  let sibling = element.parentElement.nextElementSibling;

  while (sibling) {
    if (sibling.classList.contains('product__media-zoom-lightbox')) {
      return sibling;
    }
    sibling = sibling.nextElementSibling;
  }

  return null; // Return null if no closest element is found
}

function simulateButtonClick(element) {
  const event = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  });
  element.dispatchEvent(event);
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => {
    const closestZoomLightbox = findClosestZoomLightbox(image);
    if (closestZoomLightbox && window.matchMedia('(max-width: 749px)').matches) {
      simulateButtonClick(closestZoomLightbox);
    }
    overlay.remove();
  };
  overlay.onmousemove = (event) => moveWithHover(image, event, overlay, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();

  return overlay; // Return the overlay element
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.addEventListener('click', (event) => {
      const overlay = magnify(image, zoomRatio);
      moveWithHover(image, event, overlay, zoomRatio);
    });
  });
}

enableZoomOnHover(2);
